// This should be replacing TwoButtonDialog

import { Close } from '@mui/icons-material'
import {
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  Stack,
  Typography,
  Alert,
  Box
} from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'

const CommonDialog = ({
  open,
  onClose,
  titleText,
  notificationText,
  maxWidth = 'sm',
  bodyWidth = 480,
  showDisableToggle = false,
  confirmText,
  cancelText,
  confirmValue = 1,
  cancelValue = 0,
  onCloseValue = 0,
  confirmButtonProps = {},
  cancelButtonProps = {},
  errorAlertMessage = '',
  showCloseButton,
  btnContainerProps = {},
  children
}) => {
  const { t } = useTranslation()

  const [checkDisable, setCheckDisabled] = useState(false)
  const handleSelect = value => {
    onClose(value, checkDisable)
  }

  return (
    <Dialog
      onClose={() => handleSelect(onCloseValue)}
      open={open}
      maxWidth={maxWidth}>
      <Stack padding={12} spacing={12} sx={{ width: bodyWidth }}>
        <Stack padding={0} spacing={6} width={'100%'}>
          <RowStack justifyContent='space-between'>
            <Typography variant='h4' component='span'>
              {titleText}
            </Typography>
            <Box>
              {showCloseButton && (
                <IconButton size='small' onClick={() => onClose(cancelValue)}>
                  <Close sx={{ color: colors.LightGrey400 }} />
                </IconButton>
              )}
            </Box>
          </RowStack>
          {notificationText && <Typography>{notificationText}</Typography>}
          {children}
        </Stack>
        <RowStack
          justifyContent={showDisableToggle ? 'space-between' : 'center'}>
          {showDisableToggle && (
            <FormControlLabel
              label={
                <Typography variant='body1Small'>
                  {t('stepFeedback.dontAskMeAgain')}
                </Typography>
              }
              control={
                <Checkbox
                  checked={checkDisable}
                  onChange={e => setCheckDisabled(e.target.checked)}
                  color='primary'
                  size='small'
                  sx={{ paddingX: 1 }}
                />
              }
            />
          )}
          <RowStack width='unset' spacing={4} {...btnContainerProps}>
            {cancelText ? (
              <Button
                onClick={() => handleSelect(cancelValue)}
                color='muted'
                size='small'
                {...cancelButtonProps}>
                {cancelText}
              </Button>
            ) : null}
            {confirmText ? (
              <Button
                onClick={() => handleSelect(confirmValue)}
                size='small'
                {...confirmButtonProps}>
                {confirmText}
              </Button>
            ) : null}
          </RowStack>
        </RowStack>
        {errorAlertMessage ? (
          <Alert severity='error'>{errorAlertMessage}</Alert>
        ) : null}
      </Stack>
    </Dialog>
  )
}

export default CommonDialog
